import {MuEvent, MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {
    Activity,
    ActivityFormOptions,
    ActivityVariant,
    activityVariantValueTemplate,
    Id,
    JournalActivity
} from "../../types";
import {DataStore} from "../../DataStore";
import {CommonListItem} from "../CommonListItem";
import {BasePanelWidget} from "../../BasePanelWidget";
import {DateTime} from "mu-js-utils/lib/DateTime";
import {ErrorMarker} from "mu-widget/lib/utils/ErrorMarker";
import {ErrorList} from "mu-widget/lib/utils/ErrorList";
import {Triggers} from "mu-js-utils/lib/Triggers";
import {TNames} from "../../TNames";
import {UiFlashContainer} from "mu-widget/lib/components/UiFlash";
import { UiActivityVariantSelector } from "./UiActivityVariantSelector";
import {formatDuration} from "../../filters";
import {UiComponentPreview} from "../UiComponentPreview";
import {computeNutrients} from "../../utils";

export class UiEditActivity extends BasePanelWidget {
    // @ts-ignore
    private activity: Activity;
    private state : EditActivityState = "selectVariant";
    private activityVariant: ActivityVariant | null = null;
    //@ts-ignore
    muNamedWidget: MuNamedWidgets<{
        activityVariant: UiActivityVariantSelector,
        componentPreview: UiComponentPreview,
    }>;
    private multiplier: number = 1;

    beforeIndex() {
        this.loader(true);
        this.container.classList.add('edit-activity');
        this.muAppendContent(`
            <div mu="pActivityVariant" class="edit-activity__variant d-flex-column">
                <div mu="activityVariant:UiActivityVariantSelector" class="flex-grow-1"></div>
                <hr />
                <span class="btn--link" mu="addCustom">Nenašel jsem, přidat vlastní</span>
            </div>
            <!-- <input type="search" mu="variantFilter" class="edit-activity__variant" />
            <div class="edit-activity__variant" mu="variantList#variantList:@foreach">
                <div class="edit-activity__variant-item" mu=":CommonListItem@variantItem" mu-params="click:setVariant">
                    <span class="icon-size--1rem" mu-bind="name;icon|ifEmpty('blank')|prepend('icon-size--1rem icon-before--'):className"></span>
                </div>
            </div> -->
            <div class="edit-activity__form" mu="form">
                <div class="c-form-pair">
                    <label class="c-form-pair__label" mu-for="dtStart" mu="dtStartLabel">Datum a čas</label>
                    <div class="c-form-pair__control-container">
                        <input type="datetime-local" mu="dtStart#dtStart" class="input--size-15" />
                    </div>
                </div>
                <div mu="layout_default">                
                    <div class="c-form-pair" mu="dtEndBlock">
                        <label class="c-form-pair__label" mu-for="dtEnd" mu="dtEndLabel">Datum a čas konce</label>
                        <div class="c-form-pair__control-container">
                            <input type="datetime-local" mu="dtEnd" class="input--size-15" />
                        </div>
                    </div>
                    <div class="c-form-pair" mu="valueBlock">
                        <label class="c-form-pair__label" mu-for="value" mu="valueLabel">Hodnota</label>
                        <div class="c-form-pair__control-container">
                            <div class="input-with-unit--size-15">
                                <input type="text" mu="value#value" />
                                <span mu="unit"></span>
                            </div>
                            <em mu="textValue"></em>
                        </div>
                        <div mu="sizes" class="edit-activity__sizes">
                            <span class="edit-activity__size" mu=":.@sizeItem"></span>
                        </div>
                        <div mu="componentPreview:UiComponentPreview"></div>
                    </div>
                </div>
                <div mu-for="error:values"></div>
                <div mu="layout_measure">
                    <div mu="values#values::@foreach">
                        <div class="c-form-pair" mu=":.@item">
                            <label class="c-form-pair__label" mu-for="value" mu-bind="name"></label>
                            <div class="c-form-pair__control-container">
                                <input type="number" mu="value#value;id:@attr.data-avid;activityVariantId^@attr.data-avid" />
                            </div>
                        </div>
                    </div>
                </div>
                <div mu="customValues:.#customValues" class="c-panel">
                    <strong mu="label"></strong>
                    ` + this.customValueForm() + `
                </div>
                <div class="c-form-pair" mu="noteBlock">
                    <label class="c-form-pair__label" mu-for="note">Poznámka</label>
                    <div class="c-form-pair__control-container">
                        <textarea mu="note#note"></textarea>
                    </div>
                </div>
                <div class="btn-box btn-box--expand">
                    <span mu="bSave" class="btn--primary">Uložit</span>
                    <span mu="bSaveNext" class="btn--secondary">Vložit další</span>
                    <span mu="bWatch" class="btn--secondary">Stopovat</span>
                    <span mu="bCancel" class="btn--cancel">Storno</span>
                </div>
            </div>
        `);
    }

    variantFilter_input() {
        this.muGetChildWidgets<CommonListItem>('variantList').forEach(
            w => w.muVisible(w.item.name.toLowerCase().includes(this.ui.variantFilter.value.toLowerCase()), '.')
        );
    }

    activityVariant_select(ev: MuEvent, item: ActivityVariant) {
        this.setVariant(item);
    }

    addCustom_click() {
        this.setVariant({ customValues: true });
    }

    async create(activity: Activity) {
        this.journalActivityId = null;
        this.activity = activity;
        this.ui.dtStart.value = DateTime.dateToInput(new Date(), "minute");
        if (activity.options.layout === 'measure') {
            this.state = "edit";
            const variants = await DataStore.get().getActivityVariants(activity.id);
            super.muBindData({ values: variants });
        } else {
            // if (variants && variants.length > 0) {
            if (activity.options.useVariant) {
                // super.muBindData({ variantList: variants });
                this.muNamedWidget.activityVariant.bindVariants(activity.id);
                this.state = "selectVariant";
            } else {
                this.state = "edit";
            }
        }
        this.setupForm();
        if (activity.options.inputType === 'time') this.ui.value.value = '00:00';
        this.loader(false);
    }

    setVariant(activityVariant: Partial<ActivityVariant>|null) {
        this.activityVariant = {
            activityId: null,
            customValues: false,
            name: 'Vlastní',
            icon: null,
            id: null,
            sizes: [],
            numOrder: 0,
            ...activityVariant,
        };
        this.state = "edit";
        this.setupForm();
    }

    get options(): ActivityFormOptions {
        return this.activity.options;
    }

    private setupForm() {
        this.setTitle(this.activity.name + (this.activityVariant ? (' - ' + this.activityVariant.name) : ''));
        this.muVisible(this.state === "selectVariant", [ 'pActivityVariant' ]);
        this.muVisible(this.state === "edit", 'form');
        if (this.state === "edit") {
            // custom values
            this.muVisible(this.activityVariant?.customValues ?? false, 'customValues');
            if (this.activityVariant?.customValues) {
                const customValues = this.muNamedWidget.customValues;
                customValues.ui.label.textContent = this.options.useTimeWatcher
                    ? 'Zadej spálenou energii za 1 hodinu aktivity'
                    : 'Zadej hodnoty na 100g potraviny';
                for (const k in customValues.ui) {
                    if (k.startsWith('p_')) {
                        customValues.muVisible(k === 'p_name' || k === 'p_energy' || !this.options.useTimeWatcher, k);
                    }
                }
            }
            this.ui.valueLabel.textContent = this.options.valueLabel;
            let value1Button = null;
            let sizes = this.activityVariant?.sizes ?? this.activity.options.sizes ?? [];
            if (!this.options.useTimeWatcher) sizes = [
                ...sizes,
                {
                    value: 1,
                    label: '',
                }
            ];
            this.ui.sizes.innerHTML = '';
            for (const size of sizes) {
                const buttonText = (
                    this.options.useTimeWatcher
                        ? formatDuration(size.value )
                        : size.value.toString()
                ) + (this.options.unit ?? '') + (size.label ? ' ' + size.label + '' : '');
                const buttonWidget = this.muWidgetFromTemplate(
                    'sizeItem',
                    'sizes',
                    {
                        container_click: () => {
                            if (this.options.useTimeWatcher) {
                                this.ui.value.value = DateTime.secondsToInput(size.value, 'minute');
                            } else {
                                if (this.ui.value.value === '') this.ui.value.value = '1';
                                this.multiplier = size.value;
                                this.ui.unit.textContent = size.value !== 1
                                    ? '× ' + buttonText
                                    : this.options.unit;
                                this.value_input();
                            }
                            this.ui.value.focus();
                        }
                    }
                );
                buttonWidget.container.textContent = buttonText;
                if (size.value === 1) value1Button = buttonWidget;
            }
            if (value1Button) { // @ts-ignore
                value1Button.container_click();
            }
            this.muVisible(sizes.length > 1, 'sizes');
            this.ui.value.type = this.options.inputType;
            if (this.options.minValue) this.ui.value.min = this.options.minValue.toString();
            if (this.options.maxValue) this.ui.value.max = this.options.maxValue.toString();
            this.muVisible(this.options.useTimeWatcher, ['dtEndBlock', 'bWatch']);
            this.muVisible(this.activity.code === 'food', 'bSaveNext');
            this.muVisible(this.options.valueVisible, 'valueBlock');
            this.muVisible(false, [ 'layout_default', 'layout_measure' ]);
            this.muVisible(true, 'layout_' + this.options.layout);
            this.muVisible(this.options.requireNote, 'noteBlock');
        }
        this.value_input();
    }

    value_input() {
        if (this.options.textValues) {
            const max = this.options.maxValue! - this.options.minValue!;
            const val = this.ui.value.valueAsNumber - this.options.minValue!;
            const n = Math.round(
                val * ((this.options.textValues.length - 1) / max)
            );
            this.ui.textValue.textContent = val.toString() + ' / ' + max + ' ' + this.options.textValues[n];
        }

        if (this.options.useTimeWatcher) {
            const value = Number.isNaN(this.ui.value.valueAsNumber) ? 0 :  this.ui.value.valueAsNumber;
            if (this.ui.dtStart.valueAsNumber && this.ui.value ) {
                this.ui.dtEnd.valueAsNumber = this.ui.dtStart.valueAsNumber + value;
            } else if (this.ui.dtEnd.valueAsNumber && this.ui.value ) {
                this.ui.dtStart.valueAsNumber = this.ui.dtEnd.valueAsNumber - value;
            }
        } else if (this.activityVariant) {
            this.muNamedWidget.componentPreview.muBindData(computeNutrients(
                this.activityVariant.values ?? this.muNamedWidget.customValues.muFetchData(),
                this.ui.value.valueAsNumber * (this.multiplier ?? 1),
            ));/* {
                energy: this.activityVariant.values.energy ?? 0,
                protein: this.activityVariant.values.protein ?? 0,
                carbohydrate: this.activityVariant.values.carbohydrate ?? 0,
                fat: ((this.activityVariant.values.fatSat ?? 0) + (this.activityVariant.values.fatUnsat ?? 0)),
            }); */
        }
    }

    dtStart_input() {
        this.updateDuration();
    }
    dtEnd_input() {
        this.updateDuration();
    }

    private updateDuration(ev: Event|null = null) {
        if (this.options.useTimeWatcher && this.ui.dtStart.valueAsNumber && this.ui.dtEnd.valueAsNumber) {
            if (this.ui.dtEnd.valueAsNumber < this.ui.dtStart.valueAsNumber) {
                [ this.ui.dtEnd.valueAsNumber, this.ui.dtStart.valueAsNumber] = [ this.ui.dtStart.valueAsNumber, this.ui.dtEnd.valueAsNumber ];
            }
            this.ui.value.valueAsNumber = this.ui.dtEnd.valueAsNumber - this.ui.dtStart.valueAsNumber;
        }
    }

    bCancel_click() {
        this.muParent.bPanelClose_click();
    }
    bSave_click() {
        const data = this.muFetchData();
        if (!this.activityVariant?.customValues) delete data.customValues;
        this.saveJournalActivity(
            this.journalActivityId,
            { ...data, value: this.options.useTimeWatcher
                ? DateTime.secondsFromInput(data.value)
                : parseFloat(data.value) * this.multiplier },
            false
        );
    }
    bSaveNext_click() {
        const data = this.muFetchData();
        if (!this.activityVariant?.customValues) delete data.customValues;
        this.saveJournalActivity(
            this.journalActivityId,
            { ...data, value: this.options.useTimeWatcher
                ? DateTime.secondsFromInput(data.value)
                : parseFloat(data.value) * this.multiplier },
            false,
            true
        );
    }
    bWatch_click() {
        this.saveJournalActivity(
            this.journalActivityId,
            {
                ...this.muFetchData(),
                value: null,
            },
            true
        );
    }

    protected journalActivityId: number|null = null;
    async edit(journalActivity: JournalActivity & {
        activity?: Activity;
        activityVariant?: ActivityVariant;
    }) {
        // @ts-ignore
        this.loader(true);
        const data = {
            ...journalActivity,
            activity: await DataStore.get().getActivity(journalActivity.activityId)!,
            activityVariant: await DataStore.get().getActivityVariant(journalActivity.activityVariantId)!,
            dtStart: DateTime.dateToInput(journalActivity.dtStart, 'minute'),
        };
        await this.create(data.activity!);
        // @ts-ignore
        await this.setVariant(
            !data.activityVariant && journalActivity.customValues
            ? { customValues: true, name: journalActivity.customValues.name }
            : data.activityVariant ?? null
        );
        const { values, ..._data } = journalActivity;
        this.muBindData({
            ..._data,
            value: this.valueToInput(journalActivity),
        });
        if (values) {
            // @ts-ignore
            const valuesObj: Record<any, string> = Object.fromEntries(values.map(v => [ v.activityVariantId, v.value ]));
            this.muGetChildWidgets('values').forEach(widget => {
                const activityVariantId = widget.ui.value.dataset.avid;
                if (valuesObj[activityVariantId!])
                    widget.ui.value.value = valuesObj[activityVariantId!];
            });
        }
        this.journalActivityId = journalActivity.id;
        this.value_input();
    }

    // @ts-ignore
    protected errorMarker = new ErrorMarker(this);

    private async saveJournalActivity(id: Id|null, data: any, isWatch: boolean, addNext: boolean = false): Promise<ErrorList> {
        this.loader(true);
        // validace
        const errors = new ErrorList();
        if (this.options.requireNote && !data.note) errors.add('note', 'Poznámka je povinná');
        if (!data.dtStart) errors.add('dtStart', 'Zadejte datum a čas');
        if (this.options.layout === 'measure') {
            if (!data.values.some((item:{value:string}) => item.value !== ''))
                errors.add('values', 'Zadej aspoň jednu hodnotu');
        } else {
            if (this.options.valueVisible && !data.value && data.value !== null) errors.add('value', 'Zadej hodnotu');
        }

        if (errors.isValid()) {
            const res = await DataStore.get().saveActivity(
                id,
                {
                    ...data,
                    activityId: this.activity.id,
                    activityVariantId: this.activityVariant ? this.activityVariant.id : null
                }
            );
            errors.merge(res.errors);
            if (errors.isValid()) {
                Triggers.dispatch(TNames.JournalActivityChanged);
                UiFlashContainer.add(isWatch ? 'Stopování zapnuto' : 'Zapsáno', 'success');
                if (addNext) {
                    await this.muParent.editNextActivity(this.activity);
                } else {
                    this.closeMe();
                }
            }
        }
        if (!errors.isValid()) UiFlashContainer.add('Nejprve oprav chyby', 'failed');
        this.errorMarker.markErrors(errors);
        this.loader(false);

        return errors;
    }

    private valueToInput(journalActivity: JournalActivity) {
        if (this.options.useTimeWatcher) {
            return DateTime.secondsToInput(journalActivity.value, 'minute');
        }
        return journalActivity.value;
    }

    private customValueForm() {
        return [
            { key: 'name', label: 'Název', unit: '' },
            ...activityVariantValueTemplate,
        ].map(item => `<div class="c-form-pair" mu="p_${item.key}">
            <label class="c-form-pair__label" mu-for="${item.key}">${item.label}</label>
            <div class="input-with-unit">
                <input type="${item.key === 'name' ? 'text' : 'number'}" mu="${item.key}#${item.key}">
                <span>${item.unit}</span>
            </div>
        </div>`).join('');
    }
}

type EditActivityState = 'selectVariant'|'edit';